<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('MEDICAL_DATA') }}</h3>
        </div>

        <steps v-if="!single" :activeStep="4" :steps="5" class="text-xs-center mb-4"></steps>

        <div class="content__wrapper">
            <h4 class="stepper__content__title text-xs-left">{{ $t('STRUCTURE_OF_YOUR_BREASTS') }}</h4>
            <p class="stepper__content__title-description">
                {{ $t('YOU_CAN_CHECK_THIS_ON_LAST_USG') }}
            </p>

            <div class="content__wrapper flex-center">
                <div class="flex-center flex-row">
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="GLANDULAR_OR_ADIPOSE_FAT"
                            name="radio"
                            v-model="s4q4Val"
                        />
                        <span class="input-container" style="font-size: 12px;">{{
                            $t('GLANDULAR_OR_ADIPOSE_FAT')
                        }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="FATTY_OR_FATTY_GLANDULAR"
                            name="radio"
                            v-model="s4q4Val"
                        />
                        <span class="input-container" style="font-size: 12px;">{{
                            $t('FATTY_OR_FATTY_GLANDULAR')
                        }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input class="custom-input" type="radio" value="I_DO_NOT_KNOW" name="radio" v-model="s4q4Val" />
                        <span class="input-container" style="font-size: 12px;">{{ $t('I_DO_NOT_KNOW') }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>

            <div class="text-center">
                <div v-if="single">
                    <button @click.stop="cancel()" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="s4q4Val"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>

                    <button
                        v-if="!s4q4Val"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small mt-3"
                        style="opacity: 0.5"
                    >
                        {{ $t('SAVE') }}
                    </button>
                </div>

                <div v-else>
                    <button @click.stop="goTo(3)" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('PREVIOUS') }}
                    </button>
                    <button
                        v-if="s4q4Val"
                        @click.stop="goTo(5)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>
                    <button v-if="!s4q4Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';

export default {
    mounted() {
        this.s4q4Val = this.$store.getters.survey.section4.q4;
    },
    name: 'survey-step4-q4',
    props: {
        single: Boolean,
    },
    data() {
        return {
            s4q4Val: this.s4q3,
        };
    },
    computed: {
        activeSection() {
            return this.$store.getters.survey.section4.active_section;
        },
    },
    methods: {
        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    active_section: id,
                    q4: this.s4q4Val,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    q4: this.s4q4Val,
                },
            });
            this.$emit('save');
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-step4-q4.vue?df63a55a